import { memo } from 'react';
import { Avatar } from '@mui/material';
import CameraAltOutlinedIcon from '@mui/icons-material/CameraAltOutlined';

import SectionCard from './SectionCard';
import useAvatarUpload from '../../../../hooks/useAvatarUpload';

export default memo(function AvatarSection({
  avatarPreview: initialPreview,
  firstName,
  onAvatarChange,
  onAvatarError,
}) {
  const { avatarPreview, avatarError, handleAvatarChange } = useAvatarUpload(initialPreview);

  const handleChange = (e) => {
    handleAvatarChange(e);
    const file = e.target.files[0];
    if (!file) return;

    if (file.size > 5 * 1024 * 1024) {
      onAvatarError?.('Image must be smaller than 5MB.');
      return;
    }

    onAvatarError?.('');
    const reader = new FileReader();
    reader.onloadend = () => onAvatarChange(file, reader.result);
    reader.readAsDataURL(file);
  };

  return (
    <SectionCard title="Profile Photo">
      <div className="flex items-center gap-6">
        <div className="relative">
          <Avatar
            src={avatarPreview ?? '/assets/images/profile_placeholder.jpg'}
            sx={{
              width: 96,
              height: 96,
              background: 'linear-gradient(90deg, #E54004 0%, #F6911D 100%)',
              fontSize: '2rem',
              fontWeight: 'bold',
            }}
          >
            {firstName?.charAt(0) || 'T'}
          </Avatar>
          <label
            htmlFor="avatar-upload-admin"
            className="absolute w-[35px] h-[35px] flex items-center justify-center bottom-0 right-0 bg-orange-500 hover:bg-orange-600 text-white p-1.5 rounded-full cursor-pointer transition"
          >
            <CameraAltOutlinedIcon sx={{ fontSize: 18 }} />
          </label>
          <input
            id="avatar-upload-admin"
            type="file"
            accept="image/*"
            onChange={handleChange}
            className="hidden"
          />
        </div>
        <div>
          <p className="text-white font-medium">Upload profile photo</p>
          <p className="text-gray-400 text-sm mt-1">JPG, PNG or WebP. Max 5MB.</p>
          {avatarError && <p className="text-red-400 text-sm mt-1">{avatarError}</p>}
        </div>
      </div>
    </SectionCard>
  );
});
